import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_PATIENT_DOCUMENTS,
  FAILURE_GET_PATIENT_DOCUMENTS,
  LOADING_GET_PATIENT_DOCUMENTS,
  RESET_GET_PATIENT_DOCUMENTS,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getPatientDocumentsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_PATIENT_DOCUMENTS:
      return { ...state, loading: true };
    case SUCCESS_GET_PATIENT_DOCUMENTS:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_PATIENT_DOCUMENTS:
      return { ...state, loading: false, response: null };
    case RESET_GET_PATIENT_DOCUMENTS:
      return initialState;
    default:
      return state;
  }
};
